export const splitName = (name: string) => {
  if (!name) return { first_name: '', last_name: '' };
  const nameParts = name.split(' ');
  if (nameParts.length > 1) {
    return {
      first_name: nameParts.slice(0, -1).join(' '),
      last_name: nameParts.pop(),
    };
  } else {
    return {
      first_name: name,
      last_name: '',
    };
  }
};
